export interface BranchGroupItem {
  id: number;
  chainName: string;
  branchName: string;
  subChainName?: string | null;
}

const GROUP_ORDER = [
  'שופרסל שלי',
  'שופרסל דיל',
  'שופרסל אקספרס',
  'Be',
  'יוניברס',
  'יש חסד',
  'יש בשכונה',
  'יש Good',
  'שערי רווחה',
  'דן דיל',
  'Cash&Carry',
  'רמי לוי'
];

export function subChainLabel(branch: BranchGroupItem): string {
  const name = branch.subChainName?.trim();
  return name || branch.chainName;
}

export function orderBranchesBySubChain<T extends BranchGroupItem>(branches: T[]): T[] {
  return [...branches].sort((left, right) => {
    const group = groupRank(subChainLabel(left)) - groupRank(subChainLabel(right));
    if (group !== 0) return group;
    const name = left.branchName.localeCompare(right.branchName, 'he');
    if (name !== 0) return name;
    return left.id - right.id;
  });
}

export function groupBranches<T extends BranchGroupItem>(branches: T[]): { name: string; branches: T[] }[] {
  const groups: { name: string; branches: T[] }[] = [];
  for (const branch of orderBranchesBySubChain(branches)) {
    const name = subChainLabel(branch);
    const last = groups[groups.length - 1];
    if (!last || last.name !== name) {
      groups.push({ name, branches: [branch] });
    } else {
      last.branches.push(branch);
    }
  }
  return groups;
}

function groupRank(name: string): number {
  const index = GROUP_ORDER.indexOf(name);
  return index === -1 ? GROUP_ORDER.length : index;
}

const CHAIN_ICONS: Record<string, string> = {
  שופרסל: 'assets/subchains/shufersal.svg',
  'רמי לוי': 'assets/subchains/rami-levy.png'
};

const SUBCHAIN_ICONS: Record<string, string> = {
  Be: 'assets/subchains/be.webp',
  'שופרסל שלי': 'assets/subchains/shufersal_shely.avif',
  'שופרסל אקספרס': 'assets/subchains/shufersal_express2.png'
};

export function subChainIcon(branch: BranchGroupItem): string | null {
  return SUBCHAIN_ICONS[subChainLabel(branch)] ?? CHAIN_ICONS[branch.chainName] ?? null;
}
